<script>
  import { FirebaseApp, User, Doc, Collection } from "sveltefire";
  import Card from "./Card.svelte";

  import firebase from "firebase/app";
  import "firebase/firestore";
  import "firebase/auth";
  import "firebase/performance";
  import "firebase/analytics";

  let firebaseConfig = {
    apiKey: "AIzaSyB9j5MX04nl63VOrYOqJr9ZdOa9RpFH06c",
    authDomain: "kaska-conversation.firebaseapp.com",
    databaseURL: "https://kaska-conversation.firebaseio.com",
    projectId: "kaska-conversation",
    storageBucket: "kaska-conversation.appspot.com",
    messagingSenderId: "681938606946",
    appId: "1:681938606946:web:912ac4d14116661318ea3b",
    measurementId: "G-DFYNW0BP1C"
  };

  firebase.initializeApp(firebaseConfig);
  firebase.analytics();

  let getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  let questions = [
    'What does your happy place look like?',
    'If you could learn any skill in life, what would it be?',
    'What is the weirdest thing you’ve ever done in front of others?',
    'If animals could talk, which one would be the rudest?',
    'What kind of cult would you start?',
    'Is there a right way to eat pizza?',
    'What’s your favourite dinosaur?',
    'Which historical figure would you have dinner with?',
    'What’s the one food you could never bring yourself to eat?',
    'If you could get into a time machine would you go back or forward in time?',
    'What is the best gift you’ve ever been given?',
    'What are you trying to tell the world with your outfit today?',
    'What is a false assumption people make about you all the time?',
    'What has been the greatest challenge of your year so far?',
    'Who cares a lot about you?',
    'What are you looking forward to right now?',
    'When was the last time you were really embarrassed?',
    'What are you most grateful for in life?',
    'What are some small things that make your day better?',
    'What fad or trend do you hope comes back?',
    'In what situation or place would you feel the most out of place in?',
    'What are your favourite scents?',
    'What is the best thing about you?',
    'What are you interested in, that most people haven’t heard of?',
    'What items would you take with you to a deserted island?',
    'If you could be invisible for a day what would you do?',
    'What is your perfect morning like?',
    'What have you started but never finished?',
  ];

  let shuffle = (array) => {
    var m = array.length, t, i;

    // While there remain elements to shuffle…
    while (m) {

      // Pick a remaining element…
      i = Math.floor(Math.random() * m--);

      // And swap it with the current element.
      t = array[m];
      array[m] = array[i];
      array[i] = t;
    }

    return array;
  }

  shuffle(questions);

  let pink = '#FABBB2';
  let thickGreen = '#2A8B7E';
  let pissYellow = '#FFF200';
  let linneaGreen = '#86C5AD';
  let lightMint = '#C2DEDD';
  let blueText = '#2E6066';
  let darkBlueText = '#003739';
  let white = '#ffffff';

  let colorCombos = [
    {
      primaryColor: thickGreen,
      secondaryColor: pissYellow,
    },
    {
      primaryColor: pissYellow,
      secondaryColor: linneaGreen,
    },
    {
      primaryColor: blueText,
      secondaryColor: pink,
    },
    {
      primaryColor: linneaGreen,
      secondaryColor: darkBlueText,
    },
    {
      primaryColor: white,
      secondaryColor: thickGreen,
    },
    {
      primaryColor: darkBlueText,
      secondaryColor: lightMint,
    }
  ]

  let randomColorIndex = getRandomInt(0, colorCombos.length - 1);
  let previousColorIndex = randomColorIndex;
  let root = document.documentElement;
  let i = 0;


  let switchCard = (direction) => {

    if (window.navigator.vibrate !== undefined) {
      window.navigator.vibrate(40);
    }

    if (direction === 'reverse' && i != 0) {
      i--;
    }
    else {
      i++;
    }

    // if (i < 4) {
    //   let wooshSound = document.querySelector('audio.woosh');
    //   wooshSound.play();
    // }
    if (i > questions.length - 1) {
      // console.log('from the top');
      i = 1;
    }

    // console.log(previousColorIndex, 'previousColorIndex');
    do {
      randomColorIndex = getRandomInt(0, colorCombos.length - 1);
      // console.log(randomColorIndex, 'tried');
    }
    while (previousColorIndex == randomColorIndex);
    // console.log(randomColorIndex, 'succeeded');
    previousColorIndex = randomColorIndex;
    root.style.setProperty('--primary-color', colorCombos[randomColorIndex].primaryColor);
    root.style.setProperty('--secondary-color', colorCombos[randomColorIndex].secondaryColor);

    // console.log(i);
  }

  let xDown = null;
  let yDown = null;

  let getTouches = (evt) => {
    return evt.touches;
  }

  let handleTouchStart = (evt) => {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  };

  let handleTouchMove = (evt) => {
    if (!xDown || !yDown) {
      return;
    }

    let xUp = evt.touches[0].clientX;
    let yUp = evt.touches[0].clientY;

    let xDiff = xDown - xUp;
    let yDiff = yDown - yUp;

    // Most significant direction.
    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        // Left swipe
        switchCard('forward');
      }
      else {
        // Right swipe
        switchCard('reverse');
      }
    }
    /* reset values */
    xDown = null;
    yDown = null;
  };

  document.addEventListener('touchstart', handleTouchStart, false);
  document.addEventListener('touchmove', handleTouchMove, false);

</script>

<style>
  :root {
    --primary-color: #ffffff;
    --secondary-color: #fabbb2;
  }
  @font-face {
    font-family: Ginto;
    src: url('/fonts/GintoNord.woff2');
  }

  main {
    text-align: center;
    padding: 1em;
    margin: 0 auto;
    overflow: hidden;
    display: grid;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    min-height: 100vh;
    cursor: pointer;
    color: var(--primary-color);
    user-select: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  :global(body) {
    background: var(--secondary-color);
    transition: background .2s ease-out;
  }

  :global(h1) {
    color: var(--primary-color);
    transition: color .2s ease-out;
    font-size: 6vw;
    line-height: 1.2;
    padding: 0.5em;
    display: flex;
    align-items: center;
  }

  .logo {
    width: 11em;
    display: flex;
    align-self: center;
    align-items: flex-start;
    position: fixed;
    top: 0;
    cursor: url('/media/kaska-bottle.png'), auto;
  }

  .intro {
    font-size: 8vw;
  }

  .couch {
    width: 60vw;
    transition: transform .1s ease-out;
  }

  @media (min-width: 700px) {
    .logo {
      align-self: flex-end;
    }
    .intro {
      font-size: 4vw;
      max-width: 70vw;
    }
    .couch {
      width: 20vw;
    }
  }

  .drink-lists {
    position: fixed;
    bottom: 2em;
    right: 2em;
    width: 10em;
    transition: transform .2s ease-out;
  }

  .drink-lists:hover {
    transform: rotate(-15deg);
  }

  audio {
    display: none;
  }


  .intro-wrapper {
    grid-column: 1;
    grid-row: 1;
  }

  .intro-wrapper:hover > .couch {
    transform: scale(1.2);
  }

</style>

<a class="logo" href="https://kaskadrinks.com" target="_blank"><img src="/media/kaska-logo.svg" alt=""></a>
<main on:click={switchCard}>
  <!-- 1. 🔥 Firebase App -->
  <FirebaseApp {firebase}>
    {#if !i}
      <div class="intro-wrapper">
        <h1 class="intro">Get the kånversation started</h1>
        <img class="couch" src="/media/couch.svg" alt="illustration of people sitting in a couch">
      </div>
    {:else}
      <Card on:click={switchCard} question={questions[i]}></Card>
    {/if}
  </FirebaseApp>
</main>

{#if i > 2}
  <a class="drink-lists" href="https://kaskadrinks.com/blogs/cocktails" target="_blank"><img src="/media/drink.svg" alt="a cocktail glass"></a>
{/if}

<!-- <audio class="woosh" preload controls src="/media/woosh.mp3"><track kind="captions"></audio> -->
